import styled from "styled-components";
import { themevals } from "theme/themevals";
import { bp } from "theme/themevals";


interface CustomTabWrapper {
  $vertical?: boolean;
  $sticky?: boolean;
  $fillHeight?: boolean;
}

export const TabsWrapper = styled.div<CustomTabWrapper>`    
  border-radius: 6px;
  border: 1px solid ${themevals.colors.inputOutline};
  margin-bottom: 1rem;
  ${props => props.$fillHeight ? `
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
  ` : ``}
`;

export const TabWrapper = styled.div<CustomTabWrapper>`    
  display: flex;
  flex-direction: ${props => props.$vertical ? "row" : "column"};
  align-items: stretch;  
  ${props => props.$fillHeight ? `
    flex: 1;
    min-height: 0;
    overflow: hidden;
  ` : ``}

  @media (max-width: ${bp.md}) {
    flex-direction: column;
  }
`;

export const TabContent = styled.div<CustomTabWrapper>` 
  padding: 30px 0 ;  
  flex-grow: 1; 
  ${props => props.$fillHeight ? `
    overflow-y: auto;
    min-height: 0;
  ` : ``}
`;

export const TabInner = styled.div`    
  flex-grow: 1;
`;


export const TabNav = styled.div`
  padding: 20px 0;  
  border-right: 1px solid ${themevals.colors.inputOutline};
  flex-shrink: 0;

  @media (max-width: ${bp.md}) {
    padding: 0;
    border-right: none;
    border-bottom: 1px solid ${themevals.colors.inputOutline};
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;

    /* Hide scrollbar but keep scrollability */
    scrollbar-width: none;
    &::-webkit-scrollbar { display: none; }
  }
`;

export const TabNavList = styled.ul<CustomTabWrapper>`  
  list-style: none;  
  margin: 0;
  padding: 0;  
  ${props => !props.$vertical ? `
    display: flex;
    flex-wrap: wrap;
  ` : ``}

  @media (max-width: ${bp.md}) {
    display: flex;
    flex-wrap: nowrap;
  }
`;

interface CustomTabNavLink {
  $active?: boolean;
  $vertical?: boolean;
}

export const TabNavLink = styled.li<CustomTabNavLink>`
  text-align: ${props => props.$vertical ? "right" : "center"};
  min-width: 150px;
  cursor: pointer;
  padding: 13px 21px;   
  color: ${props => props.$active ? themevals.colors.body : themevals.colors.base_500};
  border-right: 2px solid ${props => props.$active ? themevals.colors.inputOutlineDark : "transparent"};
  background-color: ${props => props.$active ? themevals.colors.inputOutline : "transparent"};
  font-family: ${themevals.fonts.body};
  font-size:14px;
  font-weight: ${props => props.$active ? 600 : 500};

  @media (max-width: ${bp.md}) {
    text-align: center;
    min-width: auto;
    white-space: nowrap;
    padding: 12px 16px;
    border-right: none;
    border-bottom: 2px solid ${props => props.$active ? themevals.colors.inputOutlineDark : "transparent"};
  }
`;

export const TabFooter = styled.div<CustomTabWrapper>`
  ${(props) => props.$sticky ? "position: sticky; bottom: 0;" : ""}
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 20px;  
  background-color: #fff;
  border-radius: 0 0 6px 6px;
  border-top: 1px solid ${themevals.colors.inputOutline};
  z-index:5;
  flex-shrink: 0;
`;
